<template>
  <span
    class="label font-weight-bold label-lg label-inline"
    v-bind:class="bindingClassLabel()"
    style="width: max-content"
    >{{ statusName || STOCK_CHECK_SHEET_STATUS_NAME[status] }}</span
  >
</template>

<script>
import { STOCK_CHECK_SHEET_STATUS } from '@/utils/enum';
import { STOCK_CHECK_SHEET_STATUS_NAME } from '@/utils/enum-name';

export default {
  props: ['status', 'statusName'],
  data() {
    return {
      STOCK_CHECK_SHEET_STATUS,
      STOCK_CHECK_SHEET_STATUS_NAME,
    };
  },
  methods: {
    bindingClassLabel() {
      return {
        'label-light-primary': this.status === STOCK_CHECK_SHEET_STATUS.NEW,
        'label-light-success': this.status === STOCK_CHECK_SHEET_STATUS.DONE,
        'label-light-warning':
          this.status === STOCK_CHECK_SHEET_STATUS.STOCK_DIFF,
        'label-light-danger':
          this.status === STOCK_CHECK_SHEET_STATUS.STOCK_DEBT,
      };
    },
  },
  created() {},
};
</script>
